export default "__VITE_ASSET__Bcz1dVZl__"